import {addTranslationForLanguage, initialize} from 'react-localize-redux';

import es from '../assets/locale/es.json';
import en from '../assets/locale/en.json';

const languages = ['es', 'en'];

const missingTranslationCallback = (key, languageCode) => {
};

const localize = (store) => {
	store.dispatch(initialize(languages, {missingTranslationCallback, showMissingTranslationMsg: false}));

	store.dispatch(addTranslationForLanguage(es, 'es'));
	store.dispatch(addTranslationForLanguage(en, 'en'));

	return store;
};

export default localize;



// WEBPACK FOOTER //
// ./src/store/localize.js